import {
  DiscreetTypography
} from "../chunk-X3MX6SC5.js";

// lib/copyright/copyright.tsx
import { jsxs } from "react/jsx-runtime";
var Copyright = ({
  className,
  year = (/* @__PURE__ */ new Date()).getFullYear()
}) => {
  return /* @__PURE__ */ jsxs(DiscreetTypography, { className, children: [
    "Copyright \xA9 ",
    year,
    " Lune Networks, LLC."
  ] });
};
export {
  Copyright
};
